// Browsers keep audio muted until the page has had a user gesture, so the
// context is created (or resumed) on the first tap or key press and a ping
// that arrives before then is silently skipped.
let audio: AudioContext | null = null;
function unlock() {
  try {
    audio ??= new AudioContext();
    if (audio.state === 'suspended') void audio.resume();
  } catch {
    audio = null;
  }
}
if (typeof window !== 'undefined') {
  for (const type of ['pointerdown', 'keydown'] as const)
    window.addEventListener(type, unlock, { capture: true, passive: true });
}

export function playPing() {
  if (!audio || audio.state !== 'running') return;
  const start = audio.currentTime;
  // A struck-bell shape: fundamental plus a quieter partial, fast attack, long decay.
  for (const [frequency, level] of [
    [1318.5, 0.22],
    [2637, 0.06],
    [3951, 0.03],
  ]) {
    const tone = audio.createOscillator();
    const envelope = audio.createGain();
    tone.type = 'sine';
    tone.frequency.value = frequency;
    envelope.gain.setValueAtTime(0.0001, start);
    envelope.gain.exponentialRampToValueAtTime(level, start + 0.008);
    envelope.gain.exponentialRampToValueAtTime(0.0001, start + 1.4);
    tone.connect(envelope).connect(audio.destination);
    tone.start(start);
    tone.stop(start + 1.5);
  }
}

export function newlyArrived(
  before: Record<string, number>,
  after: Record<string, number>,
  ignore: (id: string) => boolean,
) {
  return Object.keys(after).filter((id) => (after[id] || 0) > (before[id] || 0) && !ignore(id));
}
